import { type RubricCategory } from './rubric'

export const PITCH_EVAL_QUESTIONS: RubricCategory[] = [
  {
    code: 'C:Problem',
    title: 'Problem',
    questions: [
      {
        code: 'Q:Problem',
        title: 'Clearly stated problem understood by customer',
        value: 7,
        criteria: 'Clearly states the problem and the customer understands',
      },
      {
        code: 'Q:ProblemImpact',
        title: 'How problem affects customer',
        value: 5,
        criteria: 'Asks how the problem affects the customer',
      },
      {
        code: 'Q:ProblemLength',
        title: '3 sentences or less',
        value: 2,
        criteria: 'Explains the problem in 3 sentences or less',
      },
    ],
    skillShare: true,
  },
  {
    code: 'C:Solution',
    title: 'Solution',
    questions: [
      {
        code: 'Q:SolutionProblem',
        title: 'Correlation to problem stated',
        value: 5,
        criteria: 'Clearly states how the solution solves the problem',
      },
      {
        code: 'Q:SolutionCustomer',
        title: 'Solution correlates to customer',
        value: 3,
        criteria: 'Clearly states how the solution benefits the customer',
      },
      {
        code: 'Q:SolutionLength',
        title: '3 sentences or less',
        value: 2,
        criteria: 'Explains the solution in 3 sentences or less',
      },
    ],
    skillShare: true,
  },
  {
    code: 'C:Transition',
    title: 'Transition',
    questions: [
      {
        code: 'Q:TransitionSeeded',
        title: 'Seeded - Brought up transition beforehand (using phrases "Inside")',
        value: 5,
        criteria: 'Seeded the transition by bringing it up beforehand',
      },
      {
        code: 'Q:TransitionConfidence',
        title: 'Confidence - Assumptive statements',
        value: 5,
        criteria: 'Uses assumptive statements to transition',
      },
    ],
    skillShare: true,
  },
  {
    code: 'C:HandlingObjections',
    title: 'Handling Objections',
    questions: [
      {
        code: 'Q:Objections1',
        title: 'Brought up objection first',
        value: 5,
        criteria: 'Brought up the objection first',
      },
      {
        code: 'Q:ObjectionsCustomerAcknowledge',
        title: 'Acknowledge',
        value: 2,
        criteria: "Acknowledges the customer's objection",
      },
      {
        code: 'Q:ObjectionsCustomerAgree',
        title: 'Agree',
        value: 2,
        criteria: 'Agrees with the customer',
      },
      {
        code: 'Q:ObjectionsCustomerRestate',
        title: 'Restate',
        value: 2,
        criteria: "Restates the customer's objection",
      },
      {
        code: 'Q:ObjectionsCustomerTransition',
        title: 'Transition',
        value: 2,
        criteria: "Transitions from the customer's objection",
      },
    ],
    skillShare: true,
  },
  {
    code: 'C:Closing',
    title: 'Closing or Commitment',
    questions: [
      {
        code: 'Q:ClosingClear',
        title: 'Clear close or commitment attempt',
        value: 5,
        criteria: 'Clearly asks for the sale or next commitment (e.g., signing, scheduling install, moving forward today).',
      },
      {
        code: 'Q:ClosingAssumptive',
        title: 'Assumptive close language',
        value: 4,
        criteria: 'Uses confident, assumptive phrasing (e.g., “What works better for you…”, “We’ll get this started…”).',
      },
      {
        code: 'Q:ClosingTie',
        title: 'Ties close to customer’s stated problem/goal',
        value: 4,
        criteria: 'References the customer’s original problem, impact, or stated goal when asking for the close.',
      },
      {
        code: 'Q:ClosingNextSteps',
        title: 'Next steps explained',
        value: 2,
        criteria: 'Clearly explains what happens after the customer says yes (process, timeline, expectations).',
      },
    ],
    skillShare: true,
  },
]